import React from "react";
import { Box, Typography, TextField, Paper } from "@mui/material";

import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";

function ComplaintContactStep({
  contactName,
  phoneNumber,
  deliveryDate,

  onContactNameChange,
  onPhoneNumberChange,

  showValidation = false,

  t,
}) {
  // =========================================================
  // VALIDATION
  // =========================================================

  const contactNameError = showValidation && !contactName?.trim();

  const phoneNumberError = showValidation && !phoneNumber?.trim();

  const hasError = contactNameError || phoneNumberError;

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <Box>
      {/* =====================================================
          TITLE
      ===================================================== */}

      <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
        {t("Contact")}
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
        {t("EnterContactInformation")}
      </Typography>

      {/* =====================================================
          REQUIRED MESSAGE
      ===================================================== */}

      <Typography
        variant="body2"
        color={hasError ? "error.main" : "text.secondary"}
        sx={{ mb: 3 }}
      >
        {t("RequiredField")}
      </Typography>

      {/* =====================================================
          CONTACT INFORMATION
      ===================================================== */}

      <Paper
        variant="outlined"
        sx={{
          p: 3,
          borderRadius: 2,
          borderColor: hasError ? "error.main" : "divider",
        }}
      >
        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2.5 }}>
          {t("ContactInformation")}
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
            },
            gap: 2,
          }}
        >
          {/* =================================================
              CONTACT NAME
          ================================================= */}

          <TextField
            fullWidth
            required
            label={t("ContactName")}
            value={contactName}
            error={contactNameError}
            helperText={contactNameError ? t("ContactNameRequired") : ""}
            onChange={(event) => {
              onContactNameChange(event.target.value);
            }}
            InputProps={{
              startAdornment: (
                <PersonOutlineOutlinedIcon
                  color={contactNameError ? "error" : "action"}
                  sx={{ mr: 1 }}
                />
              ),
            }}
          />

          {/* =================================================
              PHONE NUMBER
          ================================================= */}

          <TextField
            fullWidth
            required
            label={t("PhoneNumber")}
            value={phoneNumber}
            error={phoneNumberError}
            helperText={phoneNumberError ? t("PhoneNumberRequired") : ""}
            onChange={(event) => {
              onPhoneNumberChange(event.target.value);
            }}
            type="tel"
            InputProps={{
              startAdornment: (
                <PhoneOutlinedIcon
                  color={phoneNumberError ? "error" : "action"}
                  sx={{ mr: 1 }}
                />
              ),
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
}

export default ComplaintContactStep;
